





























































































































import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import {
  IOAuthProvider,
  IOAuthProviderMethods
} from "@/models/providers/oauth";

@Component
export default class OAuthTokensList extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  @Inject("oauthProvider")
  public oauthProviderFunc!: () => IOAuthProvider;

  @Inject({ from: "oauthProviderMethods" })
  public readonly $methods!: IOAuthProviderMethods;

  @Prop({ required: true })
  public applicationCode!: string;

  // Data
  public dataModule: string = DataModules.OAUTH_TOKENS;

  // Lifecycle methos
  public created() {
    this.getData();
  }

  // Getters
  public get isLoading() {
    return this.table.loading || this.oauthProvider.isLoading;
  }

  public get showSkeleton() {
    return this.isLoading || !this.table.total;
  }

  public get oauthProvider() {
    return this.oauthProviderFunc();
  }

  // Methods
  public onSelectToken(token) {
    this.$methods.setSelectedToken(token);
  }

  public updateToken(token) {
    this.$methods.openEditTokenModal({
      props: {
        token
      },
      events: {
        success: () => {
          this.getData({ ignoreStored: true });
        }
      }
    });
  }

  public async deleteTokenConfirm(uuid) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t(`_action.delete_object`, {
            object: (this.$t("_.token") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            try {
              await this.$methods.deleteOAuthToken({ uuid });
              this.getData({ ignoreStored: true });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              confirm.close();
            }
          }
        }
      }
    });
  }

  public filterForCode() {
    return this.applicationCode
      ? {
          "filter[application.code]": this.applicationCode
        }
      : {};
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return this.$_.merge(payload, {
      params: {
        ...payload.params,
        ...this.filterForCode()
      }
    });
  }
}
